<template>
  <div>
    <div class="projects-list">      
      <div
        class="project-box"
        style="cursor: pointer"
        v-for="current in datatabla.results"
        v-bind:key="current.id"
        @click="rowClick(current)"
      >
        <div class="project-head">
          <div class="project-title">
            <h5>
              # {{ current.numero }} &nbsp;
              <span
                v-if="current.estado_str != 'Dado de baja'"
                class="badge badge-success"
                ><i class="fas fa-truck"></i> &nbsp;
                <small>{{ current.estado_str }}</small></span
              >
              <span
                v-if="current.estado_str == 'Dado de baja'"
                class="badge badge-danger"
                ><i class="fas fa-truck"></i> &nbsp;
                <small>{{ current.estado_str }}</small></span
              >
            </h5>
            <timeago
              :title="current.fecha_creacion"
              :datetime="current.fecha_creacion"
            ></timeago>
            <small><br />Destino: {{ current.tienda_destino }}</small>
          </div>
        </div>
        <div class="project-info">
          <div class="row align-items-center">
            <div class="col-12">
              <div class="row">
                <div class="col-4">
                  <div class="el-tablo highlight text-center">
                    <div v-if="current.encargado_obj" class="label">
                      Encargado
                    </div>
                    <div v-if="current.encargado_obj">
                      <strong
                        ><p class="text-center" style="color: #3ab41d">
                          {{ current.encargado_obj.name }}
                        </p></strong
                      >
                    </div>
                  </div>
                </div>
                <div class="col-4">
                  <div class="el-tablo highlight text-center">
                    <div class="label">Piloto</div>
                    <div>
                      <strong
                        ><p class="text-center" style="color: #3ab41d">
                          {{ current.piloto }}
                        </p></strong
                      >
                    </div>
                  </div>
                </div>
                <div class="col-4">
                  <div class="el-tablo highlight text-center">
                    <div class="label">Matricula</div>
                    <div>
                      <strong
                        ><p class="text-center" style="color: #3ab41d">
                          {{ current.matricula }}
                        </p></strong
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import PaginationComponent from "@/components/utils/PaginationComponent";
import UsuarioEnTablaComponent from "@/components/commons/UsuarioEnTablaComponent";
import RecepcionService from "@/services/wms/RecepcionService";
import Notifications from "@/notifications/notifications";

export default {
  props: ["datatabla"],
  components: {
    PaginationComponent,
    UsuarioEnTablaComponent,
  },
  data() {
    return {
      currentPage: 1,
    };
  },
  computed: {
    ...mapGetters({}),
  },
  mounted() {   },
  methods: {
    irAEsconderModal(name, params) {
      if ($(".modal").hasClass("show")) {
        $(".modal").find(".close").click();
      }
      this.$router.push({
        name: name,
        params: params,
      });
    },
    rowClick(current) {
      let self = this;
      if (event.ctrlKey) {
        let routeUrl = this.$router.resolve({
          name: "wms-contenedor-editar",
          params: { id: current.id },
        });
        window.open(routeUrl.href, "_blank");
      } else {
        self.$router.push({
          name: "wms-contenedor-editar",
          params: { id: current.id },
        });
      }
    },   
  },
};
</script>
